import Image from 'app/Components/Shared/Image/image';
import BtnSubmit from "app/Components/Shared/Buttons/BtnSubmit";
import React from "react";

export const InfoPopUp = (props) => {
    return <>
        <div className={'popUpContent'}>
            <Image src={require("./images/insight.svg")} alt={"icon"} />
            <p className={'popUpTitle'}>
                שימו לב
            </p>
            <p className={'content'}>מזכירים לכם שקוד האישור נדרש בהגנה במצב של רכישות והגבלת צפייה לפי גיל.<br/>
                שכחתם את הקוד? ניתן להגדיר קוד חדש בלחיצת כפתור ממש כאן </p>
            <BtnSubmit text="הבנתי, תודה" onclick={props.onclick}/>
        </div>

    </>;
}